export default __webpack_public_path__ + "static/media/premium.8f7e5647.png";